


























import TypeSelectionPopup from '@/components/popup/btt/TypeSelection.vue'
import BankAccountSelectionPopup from '@/components/popup/page/BankAccountSelection.vue'
import PasswordPopup from '@/components/popup/page/Password.vue'
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator'
import PopupHandlerMixin from '@/mixins/popupHandler'
import Translation from '@/mixins/Translation'
import DialogDrawer from '@/components/DialogDrawer.vue'
import {namespace} from 'vuex-class'

const banks = namespace('banks')
const layout = namespace('layout')
const payment = namespace('payment')

@Component({
  components: {
    DialogDrawer,
    TypeSelectionPopup,
    BankAccountSelectionPopup,
    PasswordPopup,
  },
})

export default class PaymentPopups extends Mixins(PopupHandlerMixin, Translation) {
  @Prop({default: false, type: Boolean}) isOpen: boolean
  @Prop({default: 'terms', type: String}) translation: string

  @banks.State('banks') banks
  @banks.Action('getBanks') getBanks
  @banks.Mutation('clear') clearBanks
  @layout.Mutation('updateError') updateError
  @payment.Mutation('updateBankId') updateBankId
  @payment.State('totalAmount') totalAmount

  dialogOpen: boolean = false

  get dialogProps(): object {
    const {ts} = this
    return {
      title: `${ts('payment')}하고 있습니다.`,
      description:  `5분내에 ${ts('complete')}되며, ${ts('kakaotalk')}으로 알려드리겠습니다.`,
      status: 'success',
    }
  }

  @Watch('isOpen')
  __isOpen(val) {
    if(val) {
      this.loadBanks()
    }
  }

  loadBanks() {
    const {getBanks, updateError, ts} = this
    getBanks()
      .then(() => {
        this.openPopup('bankAccountSelection')
      })
      .catch((error) => {
        updateError({
          id: 'get-banks',
          message: `${ts('bank-account')} 목록을 불러오는데 실패하였습니다.`,
        })
        throw error
      })
  }

  onSelectBank(id) {
    this.updateBankId(id)
  }

  closeAll() {
    this.clearBanks()
    this.closePopup('password')
    this.closePopup('bankAccountSelection')
    this.$emit('close')
  }
}
